import { TypographySize, SEMANTIC_TAG, TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { StyleSheet, StyleDeclarationValue, CSSProperties } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { TranslatedFontSize } from '../../theming/fontSizeTranslator';

type FontSizes = {
  fontSizeLarge: TypographySize;
  fontSizeMedium: TypographySize;
  fontSizeSmall: TypographySize;
}
export interface SemanticTagDataProps {
  styles?: StyleDeclarationValue[];
  fontSizeLarge?: TypographySize;
  fontSizeMedium?: TypographySize;
  fontSizeSmall?: TypographySize;
}

export interface SemanticTagThemeProps {
  fontSizesStyles: TranslatedFontSize;
}

export const getStyleBySize = (fontSizesStyle: TranslatedFontSize, fontSizes: FontSizes) => {
  const { fontSizeLarge, fontSizeMedium, fontSizeSmall } = fontSizes;
  return StyleSheet.create({
    tagStyle: {
      ...fontSizesStyle[fontSizeLarge].style as CSSProperties,
      [MEDIA_BREAKPOINTS.large]: {
        ...fontSizesStyle[fontSizeLarge].breakpoints.large,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        ...fontSizesStyle[fontSizeMedium].breakpoints.medium,
      },
      [MEDIA_BREAKPOINTS.small]: {
        ...fontSizesStyle[fontSizeSmall].breakpoints.small,
      },
      margin: 0,
    },
  }).tagStyle;
};

export const semanticCSS = (...styles: StyleDeclarationValue[]) => styles;

export const getFontSizesBySemanticTag = (semanticTag: SEMANTIC_TAG) => {
  switch (semanticTag) {
    case 'h1':
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.GIGANTIC,
        fontSizeMedium: TYPOGRAPHY_SIZE.GIGANTIC,
        fontSizeSmall: TYPOGRAPHY_SIZE.GIGANTIC,
      };
    case 'h2':
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.HUGE,
        fontSizeMedium: TYPOGRAPHY_SIZE.HUGE,
        fontSizeSmall: TYPOGRAPHY_SIZE.HUGE,
      };
    case 'h3':
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.LARGE,
        fontSizeMedium: TYPOGRAPHY_SIZE.LARGE,
        fontSizeSmall: TYPOGRAPHY_SIZE.LARGE,
      };
    case 'h4':
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.BIGGER,
        fontSizeMedium: TYPOGRAPHY_SIZE.BIGGER,
        fontSizeSmall: TYPOGRAPHY_SIZE.BIGGER,
      };
    case 'span':
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL,
        fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL,
        fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL,
      };
    case 'p':
    default:
      return {
        fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL,
        fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL,
        fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL,
      };
  }
};
